import React, { useMemo, useState } from 'react';
import { Facet } from '@elastic/react-search-ui';
import { groupBy } from 'lodash';
import { useTranslation } from "react-i18next";
const filterProject = parentChild => {
  if (!parentChild.includes("##")) {
    return false;
  }

  const [parent, child] = parentChild.split("##");
  if (parent && child) {
    return true;
  } else {
    return false;
  }
}
const OmronProductFacet = ({ onRemove, onSelect, options, ...rest }) => {
  const { t } = useTranslation();
  const [categoryOpenState, setCategoryOpenState] = useState({});

  const parentChildCategories = useMemo(() => {
    return groupBy(
      options
        .filter(({ value }) => filterProject(value))
        .map(option => {
          const parentChild = option.value;
          const [parentCategory, childCategory] = parentChild.split("##");
          return {
            parentCategory,
            childCategory,
            checked: option.selected,
            ...option
          };
        }),
      ({ parentCategory }) => parentCategory
    );
  }, [options]);

  return (
    <div className="l-localnav j-nav">
      <h2 className="c-title--main border">{t('Product Category')}</h2>
      <ul className="l-localnav__list level--0 u-form-label">
        {Reflect.ownKeys(parentChildCategories).map((parentCategory) => {
          const childCategories = parentChildCategories[parentCategory];
          return (
            <li key={parentCategory}>
              <div className={`parent ${categoryOpenState[parentCategory] ? 'is-open' : ''}`} onClick={(e) => {
                e.preventDefault();
                setCategoryOpenState((s) => ({ ...s, [parentCategory]: !s[parentCategory] }))
              }}>
                <button>{parentCategory}</button>
              </div>
              <ul className="l-localnav__list level--1">
                {childCategories.map((option) => {
                  return (
                    <li key={option.value}>
                      <input
                        checked={option.checked}
                        onChange={() =>
                          option.checked
                            ? onRemove(option.value)
                            : onSelect(option.value)
                        }
                        type="checkbox"
                        id={option.value}
                      />
                      <label htmlFor={option.value}>
                        {option.childCategory}
                      </label>
                      <span className="sui-multi-checkbox-facet__option-count">
                        {option.count.toLocaleString("en")}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const ProductFacetComponent = () => (
  <Facet
    field="field_faq_product_parent_child_category"
    label=""
    show={1000}
    view={props => <OmronProductFacet {...props} />}
  />
);

export default ProductFacetComponent;
